import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, CircularProgress } from '@mui/material';
import { suspenseLoaderSx } from 'src/common/CommomSxs';
import { paths } from 'src/common/config/TextMessage';

function SuspenseLoader() {
  const isBusinessProfile = location.pathname === paths?.localChecker;
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <>
      {!isBusinessProfile && (
        <Box
          sx={suspenseLoaderSx.suspenseLoaderBox}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={64} disableShrink thickness={3} />
        </Box>
      )}
    </>
  );
}

export default SuspenseLoader;
